var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 8c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 1.5,
    r: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.707 11.793-6.5-6.5c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l.139.139-9.643 9.644c-.831.831-1.289 1.936-1.289 3.111 0 2.426 1.973 4.399 4.399 4.399 1.175 0 2.28-.458 3.111-1.289l9.644-9.644.139.139c.391.391 1.023.391 1.414 0 .391-.39.391-1.022 0-1.413zm-14.707 9.207c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm4-3c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm4.973-3.58c-.4.124-.857.094-1.214-.103l-.787-.444c-.894-.493-2.049-.492-2.951.003l-.774.437c-.325.18-.732.225-1.099.145l6.198-6.198 3.393 3.393z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.96 11.71c-.408.387-1.012.387-1.42 0l-1.09-1.09 1.42-1.42 1.09 1.09c.39.39.39 1.03 0 1.42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTube);
export default __webpack_public_path__ + "static/media/test-tube.ba84f504f103a552bf1bd82e22407255.svg";
export { ForwardRef as ReactComponent };